import { useMemberFeatures } from "@/api/me";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { TopNavigation, TopNavigationBackButton } from "@/components/ui/TopNavigation";
import { Box, Flex } from "@givenwell/components";
import { styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { createFileRoute, createLink, Outlet, useCanGoBack, useNavigate, useRouter } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/claims/policy")({
  component: WhatsCovered,
});

function WhatsCovered() {
  const router = useRouter();
  const navigate = useNavigate();
  const canGoBack = useCanGoBack();

  const { hasAllowance, hasEap } = useMemberFeatures();

  return (
    <PageWrapper>
      <Box
        css={{
          px: 16,
          fontScale: "sm",
        }}
      >
        <Box css={{ maxWidth: 600, mx: "auto", display: "flex", flexDirection: "column", gap: 16 }}>
          <TopNavigation
            title="What can you claim?"
            left={
              <TopNavigationBackButton
                text="Claims"
                onClick={() => {
                  if (canGoBack) {
                    router.history.back();
                  } else {
                    navigate({ to: "/claims", replace: true });
                  }
                }}
              />
            }
            right={<></>}
          />
          {hasEap && hasAllowance && (
            <Flex css={{ justify: "center", gap: 16 }}>
              <NavTab to="/claims/policy/allowance" replace>
                Allowances
              </NavTab>
              <NavTab to="/claims/policy/eap" replace>
                Free Sessions
              </NavTab>
            </Flex>
          )}
          <Outlet />
        </Box>
      </Box>
    </PageWrapper>
  );
}

const NavTab = createLink(
  styled("a", {
    display: "flex",
    height: 40,
    items: "center",
    fontWeight: 500,

    borderBottom: `3px solid transparent`,
    "&.active": {
      borderBottomColor: colors.pink,
    },
  }),
);
